<template>
    <div class="flex min-h-screen items-center justify-center bg-surface-50 p-4 dark:bg-surface-950">
        <slot />
    </div>
</template>
